export default "__VITE_ASSET__D6t5q$VQ__"